/**
 * Syncs Recharge legacy widget one-time price when the storefront variant changes.
 * Selectors match Recharge widget DOM (e.g. label.onetime-radio span.rc-price).
 * Uses the theme price block (already updated) for formatting; falls back to variant.price + Shopify.formatMoney.
 */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function getProductInfo(sectionId) {
    return document.querySelector('product-info[data-section="' + sectionId.replace(/"/g, '\\"') + '"]');
  }

  /**
   * Formatted selling price as shown in the theme #price block (matches currency / sale state).
   */
  function readThemePriceText(sectionId) {
    var root = document.getElementById('price-' + sectionId);
    if (!root) return null;
    var wrap = root.querySelector('.price');
    if (!wrap) return null;
    var onSale = wrap.classList.contains('price--on-sale') || wrap.classList.contains('volume-pricing--sale-badge');
    if (onSale) {
      var saleEl = wrap.querySelector('.price__sale .price-item--sale');
      var t = saleEl && saleEl.textContent ? saleEl.textContent.trim() : '';
      if (t) return t;
    }
    var reg = wrap.querySelector('.price__regular .price-item--regular');
    if (reg && reg.textContent) return reg.textContent.trim();
    return null;
  }

  function formatFromCents(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt = window.themeMoneyFormat || window.money_format || (window.Shopify && Shopify.money_format);
      if (fmt) return Shopify.formatMoney(cents, fmt);
    }
    return null;
  }

  function getOneTimePriceElements(scope) {
    return scope.querySelectorAll(
      '.rc-template__radio label.onetime-radio span.rc-price, label.onetime-radio span.rc-price'
    );
  }

  function updateOneTimeLabels(sectionId, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    var productInfo = getProductInfo(sectionId);
    var scope = productInfo || document;

    var text = readThemePriceText(sectionId);
    if (!text) text = formatFromCents(variant.price);
    if (!text) return;

    getOneTimePriceElements(scope).forEach(function (el) {
      el.textContent = text;
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.sectionId || !data.variant) return;
    updateOneTimeLabels(data.sectionId, data.variant);
  });
})();
